<template lang="pug">
  div.submit
    van-form(@submit="onSubmit")
        //- van-field(v-model="game", placeholder="请选择游戏产品", disabled)
        van-field(v-if="areaColumns.length > 1", v-model="reportAreaId", @click="showArea=true", readonly, :placeholder="this.$t('reportArea')", :rules="[{required: true, message: this.$t('reportServer')}]")
        van-field(v-model="reportServer", @click="showServer=true", readonly, :placeholder="this.$t('reportServer')", :rules="[{required: true, message: this.$t('reportServer')}]")
        van-field(v-model="reportName", :placeholder="this.$t('reportName')", :rules="[{required: true, message: this.$t('reportName')}]")
        van-field(v-model="time", readonly, @click="typeShow = true", :placeholder="this.$t('cheatTime')", :rules="[{required: true, message: this.$t('cheatTime')}]")
        van-field(v-model="email", :placeholder="this.$t('inputEmailSure')", :rules="[{required: true, message: this.$t('inputEmailSure')}]")
        van-field(v-model="content", rows="3", autosize, type="textarea", maxlength="500", :placeholder="this.$t('cheatDesc')", show-word-limit, :rules="[{required: true, message: this.$t('cheatDesc')}]")
        van-field(name="uploader")
            template(#input)
                van-uploader(v-model="uploader")
        van-button(type="danger", class="submit_btn", round, :disabled='isDisabled') {{this.$t('submit')}}
        van-popup(v-model="typeShow", position="bottom")
          van-datetime-picker(v-model="currentDate", type="datetime", title="", :min-date="minDate", :max-date="maxDate", @confirm="timeConfirm", @cancel="typeShow=false", :confirm-button-text="sure", :cancel-button-text="back")
        van-popup(v-model="showArea", position="bottom")
          van-picker(show-toolbar, :columns="areaColumns", @confirm="areaConfirm", @cancel="showArea=false", :confirm-button-text="sure", :cancel-button-text="back")
        van-popup(v-model="showServer", position="bottom")
          van-picker(show-toolbar, :columns="serverColumns", @confirm="serverConfirm", @cancel="showServer=false", :confirm-button-text="sure", :cancel-button-text="back")
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Submit',
  data(){
    return{
        reportAreaId: '',
        reportServer: '',
        reportName: '',
        typeShow: false,
        type: '',
        typeId: '',
        game: '',
        reportServer: '',
        reportName: '',
        phone: '',
        email: '',
        content: '',
        uploader: [],
        updata: [],
        columns: [],
        isDisabled: false,
        time: '',
        areaId: '',
        serverId: '',
        showArea: false,
        showServer: false,
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2220, 11, 30),
        currentDate: new Date(),
        areaColumns: [],
        serverColumns: [],
    }
  },
  created(){
    this.getAreaList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        phoneModel: this.phoneModel,
        accessToken: this.token,
    })
  },
  methods:{
    ...mapActions('faq', ['report']),
    ...mapActions(['getAreaList', 'getServerList']),
    timeConfirm(val){
      const date = new Date(this.currentDate)
      this.time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + '  ' + date.getHours() + ':' + date.getMinutes()
      this.typeShow = false
    },
    onSubmit(){
      let items = this.uploader.values();
      console.log(this.uploader);
      this.updata = [];
      for(let item of items){
          this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
      }
      let count = 0
      this.updata.map(val => {
        count += val.size
      })
      if(count > 10485760){
        Toast({
          message: this.$t('limit10M'),
          type: "fail"
        })
      } else {
        if(!this.isDisabled){
          this.report({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token,
              appId: this.appid,
              channelId: this.channelId,
              email: this.email,
              content: this.content,
              cheatingTime: new Date(this.currentDate).getTime(),
              serverName: this.reportServer,
              roleName: this.reportName,
              files: this.updata,
              areaId: this.areaId,
              phoneModel: this.phoneModel,
              serverId: this.serverId
          })  
          this.isDisabled = true
        }
      }
    },
    areaConfirm(val){
      this.reportAreaId = val
      this.showArea = false
      this.areaList.areaInfoList.map(v => {
        if(v.areaName === val){
          this.areaId =  v.id
        }
      })
      this.getServerList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        phoneModel: this.phoneModel,
        areaId: this.areaId
      })
    },
    serverConfirm(val){
      this.reportServer = val
      this.showServer = false
      this.serverList.serverList.map(v => {
        if(v.serverName === val){
          this.serverId = v.serverId
        }
      })
    },

    dataURLtoFileFun (dataurl, filename, type) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: type });
    },

    pickerConfirm(v){
        this.type = v;
        this.categoryList.faqCategoryList.map(val => {
            if(val.title === this.type){
                this.typeId = val.id
            }
        });
        console.log(this.typeId)
        this.typeShow = false;
    }
  },
  computed:{
    ...mapGetters(['loading', 'uid', 'deviceId', 'token', 'appid', 'uname', 'roleName', 'serverName', 'channelId', 'lang', 'serverList', 'loadingSL', 'areaList', 'loadingAL', 'phoneModel']),
    ...mapGetters('faq', ['errmsg', 'loadingCate', 'categoryList', 'reporting', 'reportStatus']),
    sure: $vm => {
      return $vm.$t('sure')
    },
    back: $vm => {
      return $vm.$t('return')
    },
  },
  mounted(){
    this.$watch('reporting', val => {
      if(val === 'reported'){
        if(this.reportStatus === 'success'){
          Toast({
            message: this.$t('reportOk'),
            type: 'success',
            onClose: () => {
              this.$router.go(-1)
            }
          })
        } else {
          this.isDisabled = false
        }
      }
    })
    this.$watch('loadingAL', val => {
      if(val === 'loadedAL'){
        this.areaColumns = this.areaList.areaInfoList.map(val => {
          return val.areaName
        })
        if(this.areaColumns.length < 2){
          this.areaId = this.areaList.areaInfoList[0].id
          this.getServerList({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            phoneModel: this.phoneModel,
            accessToken: this.token,
            areaId: this.areaList.areaInfoList[0].id
          })
        }
      }
    })
    this.$watch('loadingSL', val => {
      if(val === 'loadedSL'){
        this.serverColumns = this.serverList.serverList.map(val => {
          return val.serverName
        })
      }
    })
    this.$watch('reportAreaId', val => {
      this.reportServer = ''
    })
  }
}
</script>
<style lang="scss">
.submit{
    color: #c8c9cc;
    margin: 20px;
    .submit_select{
        position: relative;
        .van-field__body{
            &::after {
                position: absolute;
                top: 50%;
                right: -4px;
                margin-top: -5px;
                border: 3px solid;
                border-color: transparent transparent #dcdee0 #dcdee0;
                -webkit-transform: rotate(-45deg);
                transform: rotate(-45deg);
                opacity: 0.8;
                content: '';
            }
        }
    }
    .van-field{
        margin-top: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .submit_btn{
        margin-top: 10px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>